import InputType from "common/form/InputType";
import { Input } from "decorator-form";
import SubFormWidget from "../../../../common/form/widgets/SubFormWidget";
import TopicComponentConfig, { topicFormWidget } from "./TopicComponentConfig";


/**
 * Configuration fragment for this component.
 * Add this to the config of panels that use it.
 */

export default class TopicListConfig {

	@Input({type: InputType.NUMBER, title: "Max thread depth"})
	maxDepth: number = 1;

	@Input({type: InputType.CHECKBOX, title: "Hide flagged posts until approved"})
	hideFlagged: boolean;

}

export const listFormWidget = SubFormWidget.registerForm(TopicListConfig);



// WEBPACK FOOTER //
// ./src/panels/forum/component/topic/TopicListConfig.ts